import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["clearFilters"]
  static values = {
    filterParams: Array
  }

  connect() {
    this.updateClearFiltersVisibility()
    window.addEventListener('popstate', this.updateClearFiltersVisibility.bind(this))
  }

  disconnect() {
    window.removeEventListener('popstate', this.updateClearFiltersVisibility.bind(this))
  }

  updateClearFiltersVisibility() {
    if (!this.hasClearFiltersTarget) return

    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)
    const hasActiveFilters = this.filterParamsValue.some(param => params.has(param))
    
    this.clearFiltersTarget.classList.toggle('hidden', !hasActiveFilters)
  }

  filtersChanged() {
    this.updateClearFiltersVisibility()
  }
} 
